export default {
  nome: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  document: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  diasAtrasoInicio: {
    value: '',
    required: false,
    state: null
  },
  diasAtrasoFinal: {
    value: '',
    required: false,
    state: null
  },
  valorInicial: {
    value: 0,
    required: false,
    state: null
  },
  valorFinal: {
    value: 0,
    required: false,
    state: null
  },
  operacao: {
    value: null,
    required: false,
    state: null
  },
  interacao: {
    value: null,
    options: [
      { text: 'SIM', value: true },
      { text: 'NÃO', value: false }
    ],
    required: true,
    state: null
  },
  dataInteracaoInicial: {
    value: null,
    required: null,
    state: null
  },
  dataInteracaoFinal: {
    value: null,
    required: null,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/cobranca/search/search-form.js